// extracted by mini-css-extract-plugin
export default {"innerWrapper":"uC-z","tooltipWrapper":"vC-z","icon":"wC-z","tooltip":"xC-z","content":"yC-z"};